import { useState } from "react";
import API from "../services/api";

export default function TransportAssignment() {
  const [studentId, setStudentId] = useState("");
  const [routeId, setRouteId] = useState("");
  const today = new Date().toISOString().split("T")[0];
  const [assignedDate, setAssignedDate] = useState(today);

  const handleAssign = async () => {
    try {
      await API.post("/transport/assign-student", {
        student_id: studentId,
        route_id: routeId,
        assigned_date: assignedDate
      });

      alert("Student transport assigned successfully");

      setStudentId("");
      setRouteId("");
      setAssignedDate(today);

    } catch (err) {
      alert("Transport assignment failed");
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">
        Student Transport Assignment
      </h1>

      <div className="bg-white shadow p-6 rounded">

        <input
          placeholder="Student ID"
          value={studentId}
          onChange={(e) => setStudentId(e.target.value)}
          className="border p-2 mb-3 w-full"
        />

        <input
          placeholder="Route ID"
          value={routeId}
          onChange={(e) => setRouteId(e.target.value)}
          className="border p-2 mb-3 w-full"
        />

        <input
          type="date"
          value={assignedDate}
          onChange={(e) => setAssignedDate(e.target.value)}
          className="border p-2 mb-3 w-full"
        />

        <button
          onClick={handleAssign}
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          Assign Transport
        </button>

      </div>
    </div>
  );
}